document.addEventListener('DOMContentLoaded', function() {
  const menuSection = document.querySelector('.tab-menu__content--inner');
  menuSection.querySelectorAll('[data-line-id]').forEach(link => {
    if (link.classList.contains('active')) {
      showTabContent(link);
    }
    link.addEventListener('click', function(e) {
      e.preventDefault();
      menuSection.querySelectorAll('[data-line-id]').forEach(item => {
        item.classList.remove('active');
      });
      link.classList.add('active');
      showTabContent(link);
    });
    
  });
});

function showTabContent(link) {
  document.querySelectorAll('[data-line-id]').forEach((html) => {
      if(html.classList.contains('tab-menu__link')) return;
      if (link.dataset.lineId === html.dataset.lineId) {
        html.style.display = 'block';
      }
      else{
        html.style.display = 'none';
      }
    })
}

document.querySelectorAll('.tab-menu__link').forEach(link => {
  const text = link.textContent.trim();
  if (text && text === text.toUpperCase()) {
    link.style.fontSize = '12px';
    link.style.letterSpacing = '-.9px';
  } 
});